export default __webpack_public_path__ + "static/media/030_corner1.first.1cdd9545.png";